import { Box, ButtonProps, useMediaQuery, useTheme } from "@mui/material";
import { GridAddIcon, GridDeleteIcon } from "@mui/x-data-grid";
import { useQueryClient } from "@tanstack/react-query";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
// import { ReactComponent as Export } from "../../assets/icons/export.svg";
import { COLORS } from "../../assets/theme";
import Actions from "../../components/common/Actions";
import CustomDialog from "../../components/common/CustomDialog";
import CustomLabel from "../../components/common/CustomLabel";
import CustomTable from "../../components/common/table/CustomTable";
import SearchHeaderContainer from "../../components/common/table/SearchHeaderContainer";
import ToastNotification from "../../components/ToastNotification";
import {
  addRoleApi,
  deleteRolesApi,
  editRoleApi,
//   exportRole,
  getRoleById,
  RoleType,
  useRoleQuery,
  useRolesQuery,
} from "../../services/RoleService";
import {
  DateRange,
  Option,
  IField,
  Params,
} from "../../types/table/interfaces.type";
import { useCustomerOptionsQuery } from "../../services/ClientService";
import AccountNamesTable from "../../components/AccountnameDialog";

const RolePage: React.FC = () => {
  const queryClient = useQueryClient();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [appliedFilters, setAppliedFilters] = useState<
    Params<RoleType & DateRange>
  >({
    search: "",
  });

  const dialogRef = useRef<RoleDialogRef>(null);
  const [selectedRowIds, setSelectedRowIds] = useState<string[]>([]);

  const onRowSelect = (row: RoleType, checked: boolean) => {
    console.log(`Row ID ${row.id} selection changed: ${checked}`);
    setSelectedRowIds((prevSelected) => {
      const newSelected = checked
        ? [...prevSelected, String(row.id)]
        : prevSelected.filter((id) => id !== String(row.id));
      console.log("Selected row IDs:", newSelected);
      return newSelected;
    });
  };

  const isRowSelected = (row: RoleType) =>
    selectedRowIds.includes(String(row.id));

  const handleOpenDialog = (
    mode: "add" | "edit" | "delete" | "Accounts",
    id?: string
  ) => {
    dialogRef.current?.openDialog(mode, id);
  };
  const [RoleOtions, setRoleOptions] = useState<Option[]>([]);

  const { data: RolesOptions = [] } = useRolesQuery();

  useEffect(() => {
    if (RolesOptions) {
      setRoleOptions(RolesOptions);
    }
  }, [RolesOptions]);
  const handleSearchChange = (search: string) => {
    setAppliedFilters((prev: any) => ({ ...prev, search }));
  };

 

  const actions = Actions({
    // handleOpenEditModal: {
    //   handler: async (id: string | number) => {
    //     handleOpenDialog("edit", String(id));
    //   },
    // },
    // onDelete: {
    //   handler: async (id: string | number) => {
    //     console.log(`Delete action triggered for ID: ${id}`);
    //     handleOpenDialog("delete", String(id));
    //   },
    //   isDisabled: false,
    // },
    // onListAccounts: {
    //   handler: (row: any) => {
    //     handleOpenDialog("Accounts", String(row.id));
    //   },
    //   isDisabled: false,
    // },
  });



  const fields: IField<RoleType>[] = [
    { key: "name", header: "Role Name" },
    { key: "createdDate", header: "Created Date" },
    { key: "createdBy", header: "User" },
  ];

  return (
    <Box padding={isSmallScreen ? 2 : 3}>
 <Box sx={{ mb: 3 }}>
        <CustomLabel
          text="Role List"
          variant={isSmallScreen ? "h6" : "h5"}
          fontWeight={500}
          marginTop={1}
          marginBottom={1}
        />
        <SearchHeaderContainer
          search={appliedFilters.search ?? ""}
          setSearch={handleSearchChange}
          buttonConfig={[
            {
              size: "small",
              bgColor: COLORS.GOLD,
              startIcon: <GridAddIcon />,
              onClick: () => handleOpenDialog("add"),
              textColor: COLORS.iconColor,
              permission: "POST_ROLE",
            },
            {
              size: "small",
              bgColor: COLORS.GOLD,
              variant: "outlined" as ButtonProps["variant"],
              startIcon: <GridDeleteIcon />,
              onClick: () => handleOpenDialog("delete"),
              textColor: COLORS.iconColor,
              permission: "DELETE_ROLE",
            },
            // {
            //   size: "small",
            //   bgColor: COLORS.GOLD,
            //   startIcon: <Export />,
            //   onClick: () => {
            //     exportRole({
            //       ...appliedFilters,

            //     });
            //   },
            //   textColor: COLORS.iconColor,
            //   label: "Export",
            // },
          ]}
        />

        <CustomTable<RoleType>
          filters={appliedFilters}
          fields={fields}
          fetchFunc={useRoleQuery}
          actions={actions}
          checkboxSelect={true}
          onRowSelect={onRowSelect}
          isRowSelected={isRowSelected}
          sortableFields={["name", "createdDate", "createdBy"]}
        />
      </Box>
      <RoleDialog
        ref={dialogRef}
        RoleOtions={RoleOtions}
        selectedRowIds={selectedRowIds}
        onClearSelection={() => setSelectedRowIds([])}
        onRefresh={() => {
          setAppliedFilters((prev: any) => ({ ...prev }));
          queryClient.invalidateQueries();
        }}
      />
    </Box>
  );
};

interface RoleDialogRef {
  openDialog: (
    mode: "add" | "edit" | "delete" | "Accounts",
    id?: string
  ) => void;
}

interface RoleDialogProps {
  onRefresh: () => void;
  RoleOtions: Option[];
  selectedRowIds: string[];
  onClearSelection: () => void;
}

const RoleDialog = forwardRef<
  RoleDialogRef,
  RoleDialogProps
>(({ onRefresh, RoleOtions, selectedRowIds, onClearSelection }, ref) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMode, setDialogMode] = useState<
    "add" | "edit" | "delete" | "Accounts"
  >("add");
  const [dialogData, setDialogData] = useState<Partial<RoleType>>({});
  const [selectedId, setSelectedId] = useState<string | undefined>();
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);
  const [errors, setErrors] = useState<{ [key: string]: boolean }>({});

  const { data: accountNames } = useCustomerOptionsQuery(dialogData.id ?? "", {
    enabled: Boolean(dialogData.id),
  });
  useImperativeHandle(ref, () => ({
    openDialog: (mode, id) => {
      setDialogMode(mode);
      setSelectedId(id);
      setDialogOpen(true);
      openDialog(mode, id);
    },
  }));

  const validateField = (field: string, value: string) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [field]: !value,
    }));
  };

  useEffect(() => {
    const isAnyFieldEmpty = !dialogData.name;
    setIsSaveDisabled(isAnyFieldEmpty);
  }, [dialogData]);

  const resetDialogData = () => {
    setDialogData({});
    setDialogOpen(false);
    setIsSaveDisabled(true);
  };

  const openDialog = async (
    mode: "add" | "edit" | "delete" | "Accounts",
    id?: string
  ) => {
    setDialogMode(mode);
    try {
      if (mode === "edit") {
        if (!id) {
          console.warn("ID is required to edit a Role.");
          return;
        }
        const RoleData = await getRoleById(id);
        setDialogData(RoleData);
      } else if (mode === "delete" && id) {
        setDialogData({ id });
      } else if (mode === "Accounts" && id) {
        setDialogData({ id });
      } else {
        setDialogData({
          name: "",
          createdDate: new Date().toISOString(),
          createdBy: "",
        });
      }
    } catch (error: any) {
      console.error(
        `Error fetching Role data for ${mode} mode:`,
        error
      );
    }
  };

  const addRole = async (data: Partial<RoleType>) => {
    try {
      await addRoleApi(data);
      onRefresh();
      setDialogOpen(false);
      setDialogData({});
      ToastNotification.success("Role added successfully!");
    } catch (error: any) {
      ToastNotification.error(error.message);
    }
  };

  const editRole = async (data: Partial<RoleType>) => {
    try {
      if (!data.id) {
        console.warn("ID is missing for editing the Role.");
        ToastNotification.warning("Role ID is missing.");
        return;
      }

      const { id, ...dataToUpdate } = data;
      const updatedPlan = await editRoleApi(id, {
        ...dataToUpdate,
        createdDate: data.createdDate,
      });

      console.log("Role updated successfully:", updatedPlan);
      onRefresh();
      setDialogOpen(false);
      ToastNotification.success("Role updated successfully!");
    } catch (error: any) {
      ToastNotification.error(error.message);
    }
  };

  const deleteRole = async () => {
    try {
      await deleteRolesApi(selectedRowIds);
      ToastNotification.success("Selected Roles deleted successfully!");
      onClearSelection();
      onRefresh();
      setDialogOpen(false);
    } catch {
      ToastNotification.error("Error deleting selected Roles.");
    }
  };

  return (
    <CustomDialog
      open={dialogOpen}
      onClose={resetDialogData}
      mode={dialogMode}
      title={
        dialogMode === "add"
          ? "Add Role"
          : dialogMode === "edit"
          ? "Edit Role"
          : dialogMode === "Accounts"
          ? "Linked Accounts Names"
          : "Delete Role"
      }
      fields={
        dialogMode === "delete"
          ? [
              {
                type: "custom",
                component: (
                  <Box>
                    <p>Are you sure you want to delete this ?</p>
                  </Box>
                ),
              },
            ]
          : dialogMode === "Accounts"
          ? [
              {
                type: "custom",
                component: (
                  <AccountNamesTable accountNames={accountNames || []} />
                ),
              },
            ]
          : [
              {
                type: "text",
                label: "Name Role",
                bgColor: COLORS.WhiteBackground,
                highlightLabelStar: true,
                value: dialogData.name || "",
                onChange: (value) => {
                  setDialogData((prev: any) => ({
                    ...prev,
                    name: String(value),
                  }));
                  validateField("name", value as string);
                },
                placeholder: "Enter Name",
                error: !!errors.name,
                helperText: errors.name ? "Name is required" : "",
              },
            ]
      }
      buttons={
        dialogMode === "Accounts"
          ? []
          : dialogMode !== "delete"
          ? [
              {
                label: "Save",
                variant: "contained" as "contained",
                bgColor: COLORS.GOLD,
                borderRadius: "12px",
                onClick: async () => {
                  if (dialogMode === "edit") {
                    await editRole(dialogData);
                  } else {
                    await addRole(dialogData);
                  }
                },
                disabled: isSaveDisabled,
              },
            ]
          : [
              {
                label: "Delete",
                variant: "contained" as "contained",
                bgColor: COLORS.GOLD,
                textColor: COLORS.iconColor,
                borderRadius: "12px",
                onClick: deleteRole,
              },
            ]
      }
    />
  );
});
export default RolePage;
